module.exports = __webpack_public_path__ + "static/media/lower_swoosh.a631db2f.png";